import { jsx as a, Fragment as l } from "react/jsx-runtime";
import { useCallback as p } from "react";
import { Toast as f } from "./Toast.js";
import { v4 as m } from "uuid";
import { useShallow as T } from "zustand/react/shallow";
import { createWithEqualityFn as g } from "zustand/traditional";
const y = (o) => {
  const t = m();
  return {
    ...o,
    id: t,
    open: !0
  };
}, h = (o, t) => (r) => {
  const n = y(r);
  return o((e) => ({
    toasts: [...e.toasts, n]
  })), () => t().hideById(n.id);
}, c = g((o, t) => {
  const r = h(o, t);
  return {
    toasts: [],
    default: (n, e = {}) => r({
      ...e,
      messageType: "default",
      children: n
    }),
    success: (n, e = {}) => r({
      ...e,
      messageType: "success",
      children: n
    }),
    info: (n, e = {}) => r({
      ...e,
      messageType: "info",
      children: n
    }),
    error: (n, e = {}) => r({
      ...e,
      messageType: "error",
      children: n
    }),
    warning: (n, e = {}) => r({
      ...e,
      messageType: "warning",
      children: n
    }),
    loading: (n, e = {}) => r({
      ...e,
      duration: 1 / 0,
      messageType: "loading",
      children: n
    }),
    hideById: (n) => {
      o((e) => {
        const s = e.toasts.findIndex((u) => u.id === n), i = e.toasts[s], d = [...e.toasts];
        return d.splice(s, 1, {
          ...i,
          open: !1
        }), {
          toasts: d
        };
      });
    },
    removeById: (n) => o((e) => {
      const s = e.toasts.findIndex((d) => d.id === n), i = [...e.toasts];
      return i.splice(s, 1), {
        toasts: i
      };
    })
  };
}), w = () => {
  const { toasts: o, hideById: t, removeById: r } = c(), n = p(
    (e) => e.open && !!o.find((s) => s.id === e.id),
    [o]
  );
  return /* @__PURE__ */ a(l, { children: o.map((e) => /* @__PURE__ */ a(
    f,
    {
      onExit: () => {
        e.id && r(e.id);
      },
      open: n(e),
      onOpenChange: (s) => {
        e.id && !s && t(e.id);
      },
      ...e
    },
    e.id
  )) });
}, C = () => c(
  T((o) => ({
    success: o.success,
    info: o.info,
    error: o.error,
    warning: o.warning,
    loading: o.loading,
    default: o.default
  }))
), E = w;
export {
  E as Queue,
  w as ToastQueue,
  C as useToast,
  c as useToastStore
};
